import { PageLoader } from '@gds/PageLoader/PageLoader';

import { VideoIframeProps } from './VideoIframe.entity';

import styles from './VideoIframe.module.css';

const VideoIframe = ({ title = '', video }: VideoIframeProps) => {
  if (!video) return null;

  const videoUrl =
    video[0].type === 'embed-youtube'
      ? `https://www.youtube-nocookie.com/embed/${video[0].link}?autoplay=1`
      : video[0].link;

  return (
    <div className={styles.videoWrapper} data-test-id="iframe-video-wrapper">
      <PageLoader isPage={false} isAbsolute />
      <iframe
        title={title}
        src={videoUrl}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className={styles.iframe}
        frameBorder={0}
      />
    </div>
  );
};

export default VideoIframe;
